import Icon from "@ant-design/icons/lib/components/Icon";

const MailSVG = () => (
    <svg
        width="24"
        height="19"
        viewBox="0 0 24 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.17857 2.54545L11.2173 8.94174C11.6882 9.2776 12.3118 9.27759 12.7827 8.94174L21.8214 2.54545M3.75 18H20.25C21.7688 18 23 16.7315 23 15.1667V3.83333C23 2.26853 21.7688 1 20.25 1H3.75C2.23122 1 1 2.26853 1 3.83333V15.1667C1 16.7315 2.23122 18 3.75 18Z"
            stroke="#FECC7B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const Mail = (props) => <Icon component={MailSVG} {...props} />;
